// extracted by mini-css-extract-plugin
module.exports = {"priceInputContainer":"JsMuE","priceInput":"W2Fgn","priceTitle":"_1jrCH","bg":"_3ndkL","open":"QGMEC","saveBtn":"SSm77"};